/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeControlMappingDto
 */
export interface InitiativeControlMappingDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    controlName?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    mappingSource?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeControlMappingDto
     */
    aiConfidence?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeControlMappingDto
     */
    notes?: string;
}

/**
 * Check if a given object implements the InitiativeControlMappingDto interface.
 */
export function instanceOfInitiativeControlMappingDto(value: object): value is InitiativeControlMappingDto {
    return true;
}

export function InitiativeControlMappingDtoFromJSON(json: any): InitiativeControlMappingDto {
    return InitiativeControlMappingDtoFromJSONTyped(json, false);
}

export function InitiativeControlMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeControlMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlName': json['controlName'] == null ? undefined : json['controlName'],
        'mappingSource': json['mappingSource'] == null ? undefined : json['mappingSource'],
        'aiConfidence': json['aiConfidence'] == null ? undefined : json['aiConfidence'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function InitiativeControlMappingDtoToJSON(json: any): InitiativeControlMappingDto {
    return InitiativeControlMappingDtoToJSONTyped(json, false);
}

export function InitiativeControlMappingDtoToJSONTyped(value?: InitiativeControlMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'initiativeId': value['initiativeId'],
        'frameworkSlug': value['frameworkSlug'],
        'controlId': value['controlId'],
        'controlName': value['controlName'],
        'mappingSource': value['mappingSource'],
        'aiConfidence': value['aiConfidence'],
        'notes': value['notes'],
    };
}

